module.exports = __webpack_public_path__ + "static/media/colab_cover.04057367.jpg";